export default "__VITE_ASSET__Mn3Iz57H__"